module.exports = __webpack_public_path__ + "img/allBank.a1444921.png";